import ArrowLeft from "@uui/ArrowLeft";

import Button from "@mui/material/Button";
import styled from "@mui/material/styles/styled";

import { Row } from "@rui/Stack";

const StyledButton = styled(Button)(({ theme }) => ({
  "&:not(:hover)": {
    color: theme.palette.shades.neutral[500],
  },
  fontWeight: 400,
  "& .MuiButton-startIcon svg": {
    fontSize: "16px",
  },
}));

const BackToSignUpOptions = ({ onClick }: { onClick: () => void }) => (
  <Row variant="left" marginTop="38px">
    <StyledButton onClick={onClick} startIcon={<ArrowLeft />}>
      Back to sign up options
    </StyledButton>
  </Row>
);

export default BackToSignUpOptions;
